import React from "react";
import { IComment } from "../../models/taskManagement.model";

interface TaskManagerCommentsProps {
  comments: IComment[];
  onAddClick: () => void;
  className?: string;
}

const TaskManagerComments: React.FC<TaskManagerCommentsProps> = ({
  comments,
  onAddClick,
  className = "",
}) => {
  // function renderCommentWithMentions(
  //   comment: string,
  //   mentions: { _id: string; username: string }[] = []
  // ) {
  //   let parts: (string | JSX.Element)[] = [comment];

  //   mentions.forEach((m) => {
  //     parts = parts.flatMap((part) =>
  //       typeof part === "string"
  //         ? part.split(new RegExp(`(@${m.username})`, "g")).map((p, idx) =>
  //             p === `@${m.username}` ? (
  //               <span
  //                 key={`${m._id}-${idx}`}
  //                 className="text-blue-600 font-semibold"
  //               >
  //                 {p}
  //               </span>
  //             ) : (
  //               p
  //             )
  //           )
  //         : part
  //     );
  //   });

  //   return parts;
  // }
  const renderCommentWithMentions = (
    comment: string,
    mentions: { _id: string; username: string }[]
  ) => {
    if (!comment) return null;

    // convert Quill delta-plained text into tokens, split by spaces
    const words = comment.split(/(\s+)/); // keep spaces

    return words.map((word, i) => {
      if (word.startsWith("@")) {
        const username = word.substring(1);

        const found = mentions.find((m) => m.username === username);

        if (found) {
          return (
            <span
              key={i}
              className="text-blue-600 font-medium bg-blue-50 px-1 rounded"
            >
              @{found.username}
            </span>
          );
        }
      }
      return <span key={i}>{word}</span>;
    });
  };

  if (!comments || comments.length === 0) {
    return (
      <div
        className={`bg-white rounded-xl shadow-sm border border-gray-200 ${className}`}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-sm font-semibold text-gray-900">Comment Box</h2>
          <button
            type="button"
            onClick={onAddClick}
            className="inline-flex items-center gap-2 px-2 py-1 text-xs font-medium bg-green-50 border border-green-200 rounded hover:bg-green-100 transition-all"
            aria-label="Add comment"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              className="text-green-600"
            >
              <path
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22Z"
                fill="currentColor"
              />
              <path
                d="M12 8V16M8 12H16"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
              />
            </svg>
            Add Comment
          </button>
        </div>

        <div className="p-6 space-y-3">
          <div className="text-sm text-gray-600">No comments yet.</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`bg-white rounded-xl shadow-sm border border-gray-200 ${className}`}
    >
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
        <h2 className="text-sm font-semibold text-gray-900">Comment Box</h2>
        <button
          type="button"
          onClick={onAddClick}
          className="inline-flex items-center gap-2 px-2 py-1 text-xs font-medium bg-green-50 border border-green-200 rounded hover:bg-green-100 transition-all"
          aria-label="Add comment"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            className="text-green-600"
          >
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22Z"
              fill="currentColor"
            />
            <path
              d="M12 8V16M8 12H16"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
          Add Comment
        </button>
      </div>

      <div className="p-6 space-y-3">
        <div className="space-y-4 max-h-60 overflow-y-auto">
          {comments.map((c) => (
            <div
              key={c._id ?? `${c.createdAt}-${Math.random()}`}
              className="p-3 border rounded-lg bg-gray-50 flex flex-col"
            >
              <div className="text-sm text-gray-600">
                <div
                  className="text-gray-800 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: c.comment }}
                />

                {/* {renderCommentWithMentions(
                  c.comment,
                  Array.isArray(c.mentions)
                    ? c.mentions.map((m: any) =>
                        typeof m === "string" ? { _id: m, username: m } : m
                      )
                    : []
                )} */}
              </div>
              <span className="text-xs text-gray-400 mt-1">
                {new Date(c.createdAt).toLocaleString()}
              </span>
              <span className="text-xs text-gray-500">
                {c.attachedBy ? `Attached by: ${c.attachedBy.username}` : ""}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TaskManagerComments;
